import { Component, OnInit, ViewChild } from '@angular/core'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { UserServiceCsrfTokenService } from '@se-po/shared-data-access-services'
import { SeFeDomainEnvironmentService } from 'se-fe-domain-environment'
import { VerificationSubmitter } from './verification-submit.service'

@Component({
  selector: 'se-po-household-setup-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {

  @ViewChild('accountActivatedForm') public accountActivatedForm: HTMLFormElement

  public email: string
  public loginActionUrl: string
  public uuid: string
  public csrfToken: string

  constructor(
    private env: SeFeDomainEnvironmentService,
    public store: StoreService,
    public submitter: VerificationSubmitter,
    private csrfTokenService: UserServiceCsrfTokenService
  ) { }

  public get resendAccountActivated(): boolean {
    return this.submitter.resendAccountActivated
  }
  public get resendSuccess(): boolean {
    return this.submitter.resendSuccess
  }
  public get submitting(): boolean {
    return this.submitter.submitting
  }
  public get unknownError(): boolean {
    return this.submitter.unknownError
  }

  public ngOnInit(): void {
    if (!this.store.createdAccountValid) return this.startOver()

    this.loginActionUrl = `${this.env.getUrl('userService')}users/sign_in`
    this.email = this.store.accountInfo.email
    this.uuid = this.store.createdAccount.value?.uuid
    this.csrfTokenService.fetchCsrfToken().subscribe(csrfToken => {
      this.csrfToken = csrfToken.csrf_token
    })
  }

  public startOver(): void {
    this.store.reset()
    this.submitter.reset(this.store)
  }

  public signIn(): void {
    if (!this.resendAccountActivated) return

    this.submitter.signIn(this.accountActivatedForm)
  }

  public resend(): void {
    this.submitter.resend(this.store.createdAccount.value?.uuid)
  }
}
